import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryProvider } from '@/providers/QueryProvider';
import { ThemeProvider } from '@/providers/ThemeProvider';
import { AuthProvider } from '@/providers/AuthProvider';
import { SnackbarProvider } from '@/components/feedback/Snackbar/SnackbarProvider';
import App from './App';
import { validateEnv } from '@/utils/env';

// Validate environment variables on app startup
validateEnv();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryProvider>
      <ThemeProvider>
        <SnackbarProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </SnackbarProvider>
      </ThemeProvider>
    </QueryProvider>
  </StrictMode>
);
